import { useState, type FormEvent } from "react";
import { signIn } from "../lib/auth.ts";

export function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function handleSubmit(event: FormEvent): Promise<void> {
    event.preventDefault();
    setBusy(true);
    setError(null);

    const { error: signInError } = await signIn.email({ email, password });

    if (signInError) {
      setError(
        signInError.message ?? "No se pudo iniciar sesión. Revisa los datos.",
      );
      setBusy(false);
    }
    // Si va bien, useSession se actualiza y App renderiza la aplicacion.
  }

  return (
    <div className="center-screen">
      <form
        className="card stack"
        style={{ width: "100%", maxWidth: 380 }}
        onSubmit={handleSubmit}
      >
        <div>
          <h1>Registro de ánimo</h1>
          <p className="muted" style={{ fontSize: "0.9rem", marginTop: 4 }}>
            Inicia sesión para continuar.
          </p>
        </div>

        {error && (
          <div className="alert alert--error" role="alert">
            {error}
          </div>
        )}

        <div className="field">
          <label className="field__label" htmlFor="email">Email</label>
          <input
            id="email"
            className="input"
            type="email"
            autoComplete="username"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>

        <div className="field">
          <label className="field__label" htmlFor="password">Contraseña</label>
          <input
            id="password"
            className="input"
            type="password"
            autoComplete="current-password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>

        <button className="btn btn--block" type="submit" disabled={busy}>
          {busy ? "Entrando..." : "Entrar"}
        </button>

        <p className="subtle" style={{ textAlign: "center" }}>
          El registro público está cerrado. Las cuentas se crean desde el
          servidor con <code>npm run user:create</code>.
        </p>
      </form>
    </div>
  );
}
